/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "@angular/core";
import * as i1 from "./redirect.component";
import * as i2 from "@angular/router";
var styles_RedirectComponent = [];
var RenderType_RedirectComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_RedirectComponent, data: {} });
export { RenderType_RedirectComponent as RenderType_RedirectComponent };
export function View_RedirectComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_RedirectComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-redirect", [], null, null, null, View_RedirectComponent_0, RenderType_RedirectComponent)), i0.ɵdid(1, 49152, null, 0, i1.RedirectComponent, [i2.ActivatedRoute], null, null)], null, null); }
var RedirectComponentNgFactory = i0.ɵccf("app-redirect", i1.RedirectComponent, View_RedirectComponent_Host_0, {}, {}, []);
export { RedirectComponentNgFactory as RedirectComponentNgFactory };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/redirect/redirect.component.ngfactory.js.pre-build-optimizer.js